<!-- Nav Menu Item -->
<template>
  <li
    class="nav-item"
    v-if="!menu['puedoModulo'] || $puedoModulo(menu['puedoModulo'][0])"
  >
    <template v-if="menu.items !== null">
      <a
        href="javascript:void(0);"
        class="nav-link"
      >
        <i
          class="zmdi"
          :class="menu.action"
        ></i>
        {{ (menu.title) }}
        <template v-if="menu.label == 'New'">
          <span class="sidebar-label">{{menu.label}}</span>
        </template>
      </a>
      <ul
        class="list-unstyled sub-menu-child"
        :class="{'deep-level': menu.items.length > 10 }"
      >
        <template v-for="subMenu in menu.items">
          <li
            v-if="!subMenu['puedo'] || $puedo(subMenu['puedo'][0])"
            class="nav-item"
            :key="subMenu.title"
          >
            <router-link
              :to="subMenu.path"
              class="nav-link"
              active-class="active"
            >
              <span>{{(subMenu.title)}}</span>
              <template v-if="subMenu.label == 'New'">
                <span class="sidebar-label">{{subMenu.label}}</span>
              </template>
            </router-link>
          </li>
        </template>
      </ul>
    </template>
    <template v-else>
      <router-link
        :to="menu.path"
        class="nav-link no-arrow"
        active-class="active"
      >
        <i
          class="zmdi"
          :class="menu.action"
        ></i>
        {{(menu.title)}}
        <template v-if="menu.label == 'New'">
          <span class="sidebar-label">{{menu.label}}</span>
        </template>
      </router-link>
    </template>
  </li>
</template>

<script>
import { getCurrentAppLayout } from 'Helpers/helpers'

export default {
  props: ['menu'],

  getCurrentAppLayoutHandler () {
    return getCurrentAppLayout(this.$router)
  },
  seleccionarMenu (padre) {
    // this.$store.commit('seleccionarMenu', { menu: padre })
  }

}
</script>
